// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__7RicS","choicesWrapper":"style__choicesWrapper__502xy","choice":"style__choice__EZzb4","number":"style__number__AcmKU"};